import React from "react";
import * as Sentry from "@sentry/react";
import {
  createBrowserRouter,
  createRoutesFromChildren,
  matchRoutes,
  Routes,
  useLocation,
  useNavigationType,
} from "react-router-dom";
import { SENTRY_DSN } from "./constants";

Sentry.init({
  dsn: SENTRY_DSN,
  ignoreErrors: ["t.$_Tawk.i18next is not a function"],
  environment: SENTRY_ENV,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
  ],

  beforeSend(event) {
    // Ignore N+1 API warnings for specific endpoints
    if (event.message?.includes("N+1 API Call")) {
      // Specific endpoints
      const ignoredEndpoints = ["/overview/joint-bill-services/period/"];

      if (
        event?.request?.url &&
        ignoredEndpoints.some((ep) => event?.request?.url?.startsWith(ep))
      ) {
        return null;
      }
    }

    return event; // otherwise send event
  },
  tracesSampleRate: 0.1,
});

export const SentryRoutes = Sentry.withSentryReactRouterV6Routing(Routes);

export const sentryCreateBrowserRouter =
  Sentry.wrapCreateBrowserRouter(createBrowserRouter);
